import ThisModule from "./PageMentorsIndex";

export default ThisModule;
